import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiSlice';

const ITEMS_URL = '/items';

export const itemApi = createApi({
  reducerPath: 'itemApi',
  baseQuery,
  tagTypes: ['Item', 'User'],
  endpoints: (builder) => ({
    getItems: builder.query({
      query: () => ITEMS_URL,
      providesTags: (result = [], error, arg) => [
        'Item',
        ...result.map(({ id }) => ({ type: 'Item', id }))
      ],
    }),
    createItem: builder.mutation({
      query: (item) => ({
        url: ITEMS_URL,
        method: 'POST',
        body: item,
      }),
      invalidatesTags: [{ type: 'Item', id: 'LIST' }],
    }),
    updateItem: builder.mutation({
      query: ({ _id, ...item }) => ({
        url: `${ITEMS_URL}/${_id}`,
        method: 'PUT',
        body: item,
      }),
      invalidatesTags: (result, error, { _id }) => [{ type: 'Item', id: _id }],
    }),
    deleteItem: builder.mutation({
      query: (id) => ({
        url: `${ITEMS_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Item', id }],
    }),
  }),
});

export const {
  useGetItemsQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
} = itemApi;
